"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cards = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Cards = () => {
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "192", height: "192", fill: "currentcolor", viewBox: "0 0 256 256" }, { children: [(0, jsx_runtime_1.jsx)("rect", { x: "32", y: "80", width: "160", height: "128", rx: "8", fill: "none", stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "16" }), (0, jsx_runtime_1.jsx)("path", { d: "M64,48H216a8,8,0,0,1,8,8V176", fill: "none", stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "16" })] })));
};
exports.Cards = Cards;
